<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span
                class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon class="text-white" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

    <div
        class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary notifications-header">
            <div class="sm:hidden -ml-1 mr-3">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Notifications</div>
            <div class="ml-auto">
                <button mat-icon-button [matTooltip]="'Mark all as read'" [disabled]="unreadCount === 0"
                        (click)="markAllAsRead()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:envelope-open'">
                    </mat-icon>
                </button>
                <button mat-icon-button [matTooltip]="'Tout marquer comme non lue'"
                        [disabled]="unreadCount === (notifications?.length || 0)" (click)="markAllAsUnread()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:envelope'">
                    </mat-icon>
                </button>
            </div>
        </div>

        <!-- Filtres notifications -->
        <div class="flex flex-row items-center justify-between px-4 py-2 bg-gray-50 dark:bg-gray-800 border-b">
            <button mat-button [color]="notificationFilter==='all' ? 'primary' : undefined"
                    (click)="setFilter('all')">Toutes</button>
            <button mat-button [color]="notificationFilter==='unread' ? 'primary' : undefined"
                    (click)="setFilter('unread')">Non lues</button>
            <button mat-button [color]="notificationFilter==='read' ? 'primary' : undefined"
                    (click)="setFilter('read')">Lues</button>
            <button mat-button [color]="notificationFilter==='new' ? 'primary' : undefined"
                    (click)="setFilter('new')">Nouvelles</button>
            <button mat-button [color]="notificationFilter==='deleted' ? 'primary' : undefined"
                    (click)="setFilter('deleted')" class="ml-4">Supprimées</button>
        </div>

        <!-- Content -->
        <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">
            <!-- Notifications -->
            <ng-container *ngFor="let notification of notifications; trackBy: trackByFn">
                <div class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                     [ngClass]="{'unread': !notification.read}">

                    <div class="flex flex-auto py-5 pl-6 cursor-pointer" (click)="onNotificationClick(notification)">
                        <ng-container
                            *ngTemplateOutlet="notificationContent; context: { $implicit: notification }"></ng-container>
                    </div>

                    <!-- Actions -->
                    <div class="relative flex flex-col my-5 mr-6 ml-2">
                        <!-- Indicator -->
                        <button *ngIf="notificationFilter !== 'deleted'" class="w-6 h-6 min-h-6" mat-icon-button
                                (click)="toggleRead(notification)"
                                [matTooltip]="notification.read ? 'Mark as unread' : 'Mark as read'">
                            <span class="w-2 h-2 rounded-full" [ngClass]="{'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100': notification.read,
                                            'bg-primary': !notification.read}"></span>
                        </button>
                        <!-- Remove -->
                        <button *ngIf="notificationFilter !== 'deleted'"
                                class="w-6 h-6 min-h-6 sm:opacity-0 sm:group-hover:opacity-100" mat-icon-button
                                (click)="onDelete(notification)" [matTooltip]="'Remove'">
                            <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                        </button>
                    </div>
                </div>
            </ng-container>

            <!-- Notification content template -->
            <ng-template #notificationContent let-notification>
                <!-- Avatar or Initials -->
                <div class="flex shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full border-2"
                     [ngClass]="{
            'border-blue-500': notification.priority === 1,
            'border-green-500': notification.priority === 2,
            'border-yellow-500': notification.priority === 3,
            'border-red-500': notification.priority === 4,
            'border-gray-300 dark:border-gray-600': !notification.priority,
            'bg-gray-100 dark:bg-gray-700': !notification.sender?.avatar
         }">
                    <ng-container *ngIf="notification.sender?.avatar; else initials">
                        <img class="w-8 h-8 rounded-full overflow-hidden object-cover object-center"
                             [src]="notification.sender.avatar"
                             [alt]="'Sender avatar'">
                    </ng-container>
                    <ng-template #initials>
            <span class="text-gray-600 font-medium">
                {{ getInitials(notification.sender?.first_name, notification.sender?.last_name) }}
            </span>
                    </ng-template>
                </div>

                <!-- Title, description & time -->
                <div class="flex flex-col flex-auto">
                    <ng-container *ngIf="notification.title">
                        <div class="font-semibold line-clamp-1" [innerHTML]="notification.title"></div>
                    </ng-container>
                    <ng-container *ngIf="notification.description">
                        <div class="line-clamp-4" [innerHTML]="notification.description"></div>
                    </ng-container>
                    <div class="mt-2 text-sm leading-none text-secondary">
                        <ng-container *ngIf="notificationFilter === 'deleted' && notification.deleted_at">
                            Supprimé le {{notification.deleted_at | date:'d MMM, HH:mm'}}
                        </ng-container>
                        <ng-container *ngIf="notificationFilter !== 'deleted' && notification.read_at">
                            Lu le {{notification.read_at | date:'d MMM, HH:mm'}}
                        </ng-container>
                        <ng-container *ngIf="notificationFilter !== 'deleted' && !notification.read_at">
                            {{notification.time | date:'d MMM, HH:mm'}}
                        </ng-container>
                    </div>
                </div>
            </ng-template>

            <!-- No notifications -->
            <ng-container *ngIf="!notifications?.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div
                        class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600">
                        <mat-icon class="text-primary-700 dark:text-primary-50"
                                  [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">Aucune notification</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">Lorsque vous aurez des
                        notifications, elles apparaîtront ici.</div>
                </div>
            </ng-container>

        </div>

    </div>

</ng-template>
